<div fxLayout="row" style="margin-top: 15px; margin-bottom: 10px; margin-left: 10px; padding-left: 15px; padding-right: 15px;">
  <ng-container *ngIf="brand && !isLoadingBrand">


    <div fxFlex="50">
      <button class="mr-2" mat-raised-button color="basic" (click)="returnBack()">Back</button>


    </div>
    <div fxFlex="50" style="text-align: right">

    </div>


  </ng-container>
</div>

<div class="content-card" fxLayout="row wrap" fxLayoutGap="10px">

  <!-- #region order details -->




  <mat-card class="container-md" style="min-width: 400px">
    <mat-progress-bar mode="indeterminate" *ngIf="isLoadingBrand" class="progress-bar"></mat-progress-bar>
    <mat-card-header fxLayout="row" fxLayoutGap="10px">
      <mat-card-title>

        <div fxLayout="row" style="">
          <div fxFlex="30">
            <img src="{{brand.logoUrl}}" style="width: 100%; max-width: 140px; margin-right: 10px;" alt="Brand Logo" />
          </div>
          <div fxFlex="70">
            <h5>Brand<br />{{ brand?.name }}</h5>
            <div style="font-weight: normal; font-size: .7em; font-family: monospace">{{brand.slug}}</div>
          </div>
        </div>

        <div fxLayout="row" class="mt-1">

          <div fxFlex="100">
            <div style="font-weight: normal; font-size: .7em;">Gift card preview</div>
            <img src="{{brand.giftCardUrl}}" style="width: 100%; max-width: 140px; margin-right: 10px;" alt="Brand Logo" />
          </div>
        </div>






      </mat-card-title>
      <div fxFlex></div>
      <div>

        <!--
        <span *ngIf="false && order && order.webIdTransaction" style="margin-right: 10px;">
          <button mat-raised-button class="mr-1" color="blue" [disabled]="isResendWebidDisabled() && (order.webIdTransaction.status === 1)" (click)="resendWebIdLink(order)">Resend WebID</button>
        </span>-->


      </div>
    </mat-card-header>
    <mat-card-content class="mt-2">

      <span class="mr-2" *ngIf="!brand && !isLoadingBrand">Gift card brand not exist/or has been removed</span>
      <span class="mr-2" *ngIf="isLoadingBrand">Loading data...</span>
      <div *ngIf="brand">

        <div style="text-align: right">
          <a mat-raised-button color="primary" routerLink="edit" [disabled]="!editEnabled()">Edit</a>
        </div>



        <div class="list-item" fxLayout="row" *ngFor="let field of fieldsBrand ">
          <app-content-row [field]="field" [entity]="brand"></app-content-row>
        </div>

      </div>
    </mat-card-content>
    <mat-card-actions align="end" class="mt-2">

    </mat-card-actions>
  </mat-card>

</div>
